import React, { useEffect, useState } from 'react'
import Dropdown from '../Dropdown'

const AddPrompt = ({ onYes, message, is_premium, prompt, id, question_type, placeholder }) => {

    const [obj, setObj] = useState({
        is_premium: true,
        question_type: 1,
        prompt: ""
    });

    useEffect(() => {
        setObj({
            prompt,
            is_premium,
            question_type
        })
    }, [is_premium, prompt, question_type]);

    return (
        <div className="modal fade" id={"modal" + id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="modal-body text-center">
                        {/* <div className="modal_icon">
                            <Cancel />
                        </div> */}
                        <div className="modal_msg">
                            {message}
                        </div>
                        <br />
                        <input type='text' className='' placeholder={placeholder} value={obj.prompt} name='prompt' onChange={(e) => {
                            setObj({
                                ...obj,
                                prompt: e.target.value
                            });
                        }} />
                        <label style={{ width: "100%", textAlign: "start", marginTop: "15px" }}>Premium</label>
                        <Dropdown title={obj.is_premium ? "Yes" : "No"} onSelect={(value) => {
                            setObj({
                                ...obj,
                                is_premium: value
                            })
                        }} options={[{ _id: true, shop_name: "Yes" }, { _id: false, shop_name: "No" }]} className='' placeholder='Premium' />
                        <div className="modal_btns ">
                            <button type='button' disabled={!obj.prompt} onClick={() => {
                                onYes(obj)
                            }} data-bs-dismiss="modal">Save</button>
                            <button className='purple' data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPrompt